'use strict'

angular
  .module('basalteApp')
  .constant('BAS_LANGUAGES', {
    DEF_LANGUAGE: 'en_GB'
  })
